function fmtSecs(ms) {
  const s = Math.max(0, Math.round(ms / 1000));
  if (s < 60) return `${s}s`;
  const m = Math.floor(s / 60);
  return `${m}m ${s % 60}s`;
}
export function formatProgress(done, total, elapsedMs) {
  const t = total > 0 ? total : 0;
  const d = Math.min(Math.max(done || 0, 0), t);
  const pct = t > 0 ? Math.round((d / t) * 100) : 0;
  const doneText = `${d}/${t}`;
  let etaText = "";
  if (d > 0 && d < t && elapsedMs > 0) {
    const eta = (elapsedMs / d) * (t - d);
    etaText = `예상 ~${fmtSecs(eta)}`;
  }
  const elapsedText = `경과 ${fmtSecs(elapsedMs)}`;
  return { pct, doneText, etaText, elapsedText };
}
